import {Directive, Input, TemplateRef, ViewContainerRef} from "@angular/core";

@Directive({
	selector: '[cpVar]',
})
export class CpVarDirective{
	@Input()
	set cpVar(context: any) {
		this.context.$implicit = this.context.cpVar = context;
		this.updateView();
	}

	context: any = {};

	constructor(private vcRef: ViewContainerRef, private templateRef: TemplateRef<any>) {}

	updateView() {
		this.vcRef.clear();
		this.vcRef.createEmbeddedView(this.templateRef, this.context);
	}
}
